import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "nav-arrow",
  "use": "nav-arrow-usage",
  "viewBox": "0 0 72 72",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 72 72\" id=\"nav-arrow\">\r\n<polygon points=\"0,0 71.9,0 35.9,63 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/icons/nav-arrow.svg
// module id = null
// module chunks = 